import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'environments/environment';
import { of } from 'rxjs/observable/of';
import { catchError } from 'rxjs/operators';

@Injectable()
export class TaxiServiceInfoService {
  constructor(private http: HttpClient) {}

  getInfoAboutService(serviceId: number): Observable<any> {
    if (serviceId) {
      return this.http
        .get(`${environment.config.estimateV2}/service_stats`, {
          headers: new HttpHeaders({
            'X-Taxi-Service': `${serviceId}`
          })
        })
        .pipe(catchError(error => of(error)));
    } else {
      return of(0);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/services/taxi-service-info.service.ts